import {Header, Footer, Items} from "./components"

export const Form = {
    components: {Header, Footer, Items},
    template: `
        <div class="basket-wrapper">
               <Header />
               <Items />
        </div>
        <div class="basket-total hide_empty_bottom">
            <Footer />
        </div>
    `
}